<template>
  <div class="chatbot-message-box">
    <div
      class="chatbot-message"
      v-bind:class="[
        received ? 'chatbot-received' : 'chatbot-sent',
        sending ? 'chatbot-sending' : '',
        fixedWidth ? 'fixed-width' : ''
      ]"
      v-bind:style="{ backgroundColor, color }"
    >
      <span class="chatbot-message-content">{{ content }}</span>
      <close-circle
        v-if="sendingError"
        fillColor="#b32a2a"
        :size="20"
        class="chatbot-message-error"
      />
      <SyncLoader
        v-else-if="sending"
        class="chatbot-message-loading"
        :size="7"
        margin="2px"
        color="#888"
      />
      <span v-else class="chatbot-message-time">{{
        datetime.format("HH:mm")
      }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import CloseCircle from "vue-material-design-icons/CloseCircle.vue";

import { mapState, mapGetters } from "vuex";
import { SyncLoader } from "@saeris/vue-spinners";

export default {
  name: "Message",
  components: {
    SyncLoader,
    CloseCircle
  },
  props: {
    received: {
      type: Boolean,
      required: true
    },
    content: {
      type: String,
      required: true
    },
    datetime: {
      type: dayjs.Dayjs,
      required: true
    },
    sending: {
      type: Boolean,
      default: false
    },
    sendingError: {
      type: Boolean,
      default: false
    },
    fixedWidth: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState("settings", ["config"]),
    ...mapGetters("settings", ["themeContrastColor"]),
    ...mapGetters("messages", ["showVerticalChoices"]),
    backgroundColor() {
      return this.received ? "white" : this.config.upperBackgroundColor;
    },
    color() {
      return this.received ? "black" : this.themeContrastColor;
    }
  }
};
</script>

<style lang="scss" scoped>
.chatbot-message-box {
  overflow: auto;
  margin: 10px 0 0;

  .chatbot-message {
    max-width: 80%;
    min-width: 10%;
    display: block;
    padding: 10px 13px 20px;
    border-radius: 10px;
    position: relative;
    border: 1px solid #afafaf59;

    &.chatbot-sent {
      float: right;
      border-bottom-right-radius: 0;
    }

    &.chatbot-received {
      float: left;
      border-bottom-left-radius: 0;
    }

    &.chatbot-sending {
      opacity: 0.5;
    }
    &.fixed-width {
      width: 80%;
    }

    .chatbot-message-content {
      display: block;
    }

    .chatbot-message-time {
      position: absolute;
      right: 6px;
      bottom: 3px;
      color: #888;
      font-size: 0.8rem;
    }
    .chatbot-message-loading {
      position: absolute;
      right: 5px;
      bottom: 10px;
    }

    .chatbot-message-error {
      position: absolute;
      right: 5px;
      bottom: 0px;
    }
  }
}
</style>
